module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/modules/_add-to-unscopables.js
// module id = 157
// module chunks = 20